module.exports = ".circle {\n      width: 20px;\n      height: 20px;\n      border-radius: 50%;\n}\n"